module.exports = __webpack_public_path__ + "assets/img/servicio-adicional-etiquetado-amazon-fba-rakumart-300x300.ed90af79.png";